import { Link, useLocation } from "react-router-dom";
import { 
  Home as HomeIcon, 
  MessageCircle, 
  Waves, 
  Calendar as CalendarNav, 
  ShoppingBag,
  AlertTriangle
} from "lucide-react";

export const MobileNav = () => {
  const location = useLocation();
  
  const navItems = [
    { path: "/", icon: HomeIcon, label: "Home" },
    { path: "/concierge", icon: MessageCircle, label: "Lina" },
    { path: "/beaches", icon: Waves, label: "Beaches" },
    { path: "/upsells", icon: ShoppingBag, label: "Extras" },
    { path: "/emergency", icon: AlertTriangle, label: "Help" },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-sand-100/95 backdrop-blur-sm border-t border-sand-300 px-2 py-2 z-50 safe-area-bottom" data-testid="mobile-nav">
      <div className="flex justify-around items-center">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center py-1.5 px-3 rounded-xl transition-all ${
                isActive 
                  ? "text-olive-700" 
                  : "text-stone-400 hover:text-stone-600"
              }`}
            >
              <Icon size={20} strokeWidth={isActive ? 2 : 1.5} />
              <span className="text-[10px] mt-1 font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
